<template>
  <div class="flex size-full overflow-hidden">
    <template v-if="isLoggedIn">
      <HeadlessTransitionRoot
        as="template"
        :show="sidebarOpen"
      >
        <HeadlessDialog
          as="div"
          class="relative z-40 lg:hidden"
          @close="sidebarOpen = false"
        >
          <HeadlessTransitionChild
            as="template"
            enter="transition-opacity ease-linear duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <div class="fixed inset-0 bg-gray-600/75" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-40 flex">
            <HeadlessTransitionChild
              as="template"
              enter="transition ease-in-out duration-300 transform"
              enter-from="-translate-x-full"
              enter-to="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leave-from="translate-x-0"
              leave-to="-translate-x-full"
            >
              <HeadlessDialogPanel
                class="relative flex w-full max-w-xs flex-1 flex-col"
              >
                <HeadlessTransitionChild
                  as="template"
                  enter="ease-in-out duration-300"
                  enter-from="opacity-0"
                  enter-to="opacity-100"
                  leave="ease-in-out duration-300"
                  leave-from="opacity-100"
                  leave-to="opacity-0"
                >
                  <div
                    class="absolute right-0 top-0 -mr-12 pt-2"
                  >
                    <button
                      type="button"
                      class="ml-1 flex size-10 items-center justify-center rounded-full text-background"
                      @click="sidebarOpen = false"
                    >
                      <span class="sr-only"
                        >Close sidebar</span
                      >
                      <IconX
                        class="size-6"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </HeadlessTransitionChild>
                <TheSidebar />
              </HeadlessDialogPanel>
            </HeadlessTransitionChild>
            <div class="w-14 shrink-0" aria-hidden="true">
              <!-- Dummy element to force sidebar to shrink to fit close icon -->
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>

      <div
        class="hidden lg:inset-y-0 lg:flex lg:w-64 lg:flex-col"
      >
        <TheSidebar />
      </div>

      <div
        class="mx-auto flex h-full max-w-7xl flex-1 flex-col overflow-hidden sm:px-6 lg:px-8"
      >
        <div
          class="flex shrink-0 items-center border-b py-4"
        >
          <div
            class="border-r border-background-fg/8 px-2 lg:hidden"
          >
            <ButtonWithIcon @click="sidebarOpen = true">
              <span class="sr-only">Open sidebar</span>
              <IconThreeBars
                class="size-6"
                aria-hidden="true"
              />
            </ButtonWithIcon>
          </div>
          <h1
            class="ml-4 text-xl font-medium text-background-fg/87"
          >
            {{ pageTitle }}
          </h1>
        </div>
        <main
          class="flex h-full flex-1 flex-col overflow-y-auto p-4"
        >
          <RouterView />
        </main>
      </div>
      <!-- </div> -->
    </template>
  </div>
  <!-- <div class="flex-1" /> -->
</template>

<script setup>
const { isLoggedIn } = useAuth()
const router = useRouter()
const { pageTitle } = usePageTitle()

const route = useRoute()

watch(
  () => route.fullPath,
  () => {
    sidebarOpen.value = false
  }
)

const sidebarOpen = ref(false)

whenever(
  () => !isLoggedIn.value,
  () => router.push({ name: "login" }),
  { immediate: true }
)
</script>

<style lang="scss" module></style>
